import { useEffect } from "react";
import { IconeDownload, IconeFechar } from "./Icones";

interface PropsVisualizadorFoto {
  src: string;
  /** null quando a foto ainda está pendente de upload (fila offline) — sem id no servidor ainda,
   * não tem o que baixar. */
  urlDownload: string | null;
  onFechar: () => void;
}

/**
 * Tela cheia pra examinar uma foto da vistoria de perto (o grid de miniaturas é pequeno demais
 * pra ver detalhe) + baixar o arquivo original. Overlay simples (fecha ao clicar fora da foto ou
 * Esc) — não é o padrão de modal/overlay de formulário já abandonado nesse app (ver histórico:
 * overlay é ruim pra edição no mobile), aqui é só visualização, sem campo nenhum.
 */
export function VisualizadorFoto({ src, urlDownload, onFechar }: PropsVisualizadorFoto) {
  useEffect(() => {
    const aoTeclar = (e: KeyboardEvent) => {
      if (e.key === "Escape") onFechar();
    };
    window.addEventListener("keydown", aoTeclar);
    return () => window.removeEventListener("keydown", aoTeclar);
  }, [onFechar]);

  return (
    <div className="visualizador-foto" onClick={onFechar}>
      <div className="visualizador-foto-barra" onClick={(e) => e.stopPropagation()}>
        {urlDownload && (
          <a href={urlDownload} className="visualizador-foto-botao" title="Baixar foto">
            <IconeDownload tamanho={20} cor="#fff" />
          </a>
        )}
        <button type="button" className="visualizador-foto-botao" onClick={onFechar} title="Fechar">
          <IconeFechar tamanho={22} cor="#fff" />
        </button>
      </div>
      <img src={src} alt="" onClick={(e) => e.stopPropagation()} />
    </div>
  );
}
